module.exports = __webpack_public_path__ + "img/tuto_mobile_way_02_02.5c70a34b.png";